export default {
  className: 'vouchers',
  readonly: true,
  fields: [
    'name',
    'user',
    'status',
    'parValue',
    {
      name: 'conditionsUse',
      width: 150
    }
  ],
  search: [
    'user',
    'name',
    'status'
  ],
  action: {
    create: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看优惠券详情',
      component: 'viewPage'
    },
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, className }) => {
        if (record.status === 'alreadyUsed') {
          throw vm.$notification['error']({
            message: '不支持删除',
            description: '优惠券状态为已使用'
          })
        }
        await vm.confirm('警告', '你确定要删除该用户优惠券吗?')
        // 刪除此条用户数据 此用户id record.objectId
        let rs = await vm.$tkParse.delete(`/classes/${className}/${record.objectId}`).catch(() => {
          vm.$notification['error']({
            message: '网络错误',
            description: '删除数据失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '优惠券已被删除'
          })
          vm.refresh()
        }
      }
    }
  },
  hooks: {
    /**
     * 給查询添加条件
     * @date: 2020/3/9
     */
    beforeFetch ({ where, modelName }) {
      where.type = 'coupons'
    }
  }
}
